import React, { SVGProps } from 'react';

const AllSides = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7.25C3 7.66421 3.33579 8 3.75 8C4.16421 8 4.5 7.66421 4.5 7.25V4.5H7.25C7.66421 4.5 8 4.16421 8 3.75C8 3.33579 7.66421 3 7.25 3H4C3.44772 3 3 3.44772 3 4V7.25ZM7.25 16.9994C7.66421 16.9994 8 16.6636 8 16.2494C8 15.8352 7.66421 15.4994 7.25 15.4994H4.5V12.7494C4.5 12.3352 4.16421 11.9994 3.75 11.9994C3.33579 11.9994 3 12.3352 3 12.7494V15.9994C3 16.5517 3.44772 16.9994 4 16.9994H7.25ZM16.25 12C16.6642 12 17 12.3358 17 12.75V16C17 16.5523 16.5523 17 16 17H12.75C12.3358 17 12 16.6642 12 16.25C12 15.8358 12.3358 15.5 12.75 15.5H15.5V12.75C15.5 12.3358 15.8358 12 16.25 12ZM12.75 3C12.3358 3 12 3.33579 12 3.75C12 4.16421 12.3358 4.5 12.75 4.5H15.5V7.25C15.5 7.66421 15.8358 8 16.25 8C16.6642 8 17 7.66421 17 7.25V4C17 3.44772 16.5523 3 16 3H12.75Z"
      fill="currentColor"
    />
  </svg>
);

export default AllSides;
